// import { useCallback, useMemo } from 'react';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { hookEnabledError } from '@hcs/utils';

import { OrderManagerApi } from '../api/orderManagerApi';
import { OmOrder } from '../types';

export const QUERY_KEY_ORDER = 'order';
export const useOrder = (
  orderId: number | undefined,
  options?: Partial<
    UseQueryOptions<
      OmOrder,
      AxiosError,
      OmOrder,
      [typeof QUERY_KEY_ORDER, number | undefined]
    >
  >,
) => {
  return useQuery({
    queryKey: [QUERY_KEY_ORDER, orderId],
    queryFn: () => {
      if (!orderId) {
        throw hookEnabledError('userOrder', 'orderId');
      }
      return OrderManagerApi.fetchOrder(orderId);
    },
    ...options,
    enabled: options?.enabled !== undefined ? options.enabled : !!orderId,
  });
};
